import React from 'react';
import PropTypes from 'prop-types';

class ItemSmallLogo extends React.Component {   

    constructor(props){
        super(props);
    }
    componentWillMount(){ }
    
    componentDidMount(){ }

    render(){
        if(!this.props.src) return null;
        return (
            <div className="ItemSmallLogo"  style={{backgroundImage : `url(${this.props.src})` }} >
                <style jsx>{`
                    .ItemSmallLogo {
                        width: ${(this.props.style && this.props.style.width)? this.props.style.width : 50 }px;
                        height: ${(this.props.style && this.props.style.width)? this.props.style.width : 50 }px;
                        background-size: contain;
                        background-position: center;
                        background-repeat: no-repeat;
                        margin-right:10px;
                    }
                `}</style>
            </div>
        )
    }
}

ItemSmallLogo.propTypes = {
    src : PropTypes.string
}

export default ItemSmallLogo;


// WEBPACK FOOTER //
// ./src/components/common/ItemSmallLogo.js